import React from 'react';

type PulsingNodeProps = {
  children: React.ReactNode;
  interval?: number; // in milliseconds
  isDisabled?: boolean;
  duration?: number; // in milliseconds
};

export const PulsingNode: React.FC<PulsingNodeProps> = ({
  children,
  interval = 2000,
  duration = 1000,
  isDisabled
}) => {
  const [pulses, setPulses] = React.useState<number[]>([]);
  const pulseId = React.useRef(0);

  React.useEffect(() => {
    if (isDisabled) return;

    let timeoutId: ReturnType<typeof setTimeout> | undefined = undefined;

    const pulse = () => {
      const newId = pulseId.current++;
      setPulses((prev) => [...prev, newId]);
      timeoutId = setTimeout(() => {
        setPulses((prev) => prev.filter((id) => id !== newId));
        timeoutId = setTimeout(pulse, interval);
      }, duration); // duration of pulse animation
    };

    pulse();

    return () => clearTimeout(timeoutId);
  }, [interval, isDisabled]);

  return (
    <div className="relative inline-block">
      {children}

      {pulses.map((id) => (
        <div
          key={id}
          className="component-pulse-zoom pointer-events-none absolute inset-0"
        >
          {children}
        </div>
      ))}
    </div>
  );
};
